<script>
  import { Button, Modal } from "../../../components/index.svelte";
  import { deleteMaintenance } from "../../../helpers/apiHelpers/maintenance-management.rest.svelte";
  import { toast } from "../../../helpers/utils.svelte";
  import { translator } from "../../../store";

  export let maintenanceDetails;
  export let onModalClose;
  export function modalToggleWrapper() {
    toggler();
  }

  let toggler;

  async function onDeleteClick() {
    try {
      await deleteMaintenance(maintenanceDetails.property_id, maintenanceDetails.id);
      toast.success(translator("Başarılı"), translator("Bakım kaydı silindi"));
      modalToggleWrapper();
    } catch (err) {
      toast.error(
        translator("Hata"),
        translator(
          err.getResponseMessage ? err.getResponseMessage() : err.message
        )
      );
    }
  }
</script>

<Modal
  bind:toggle={toggler}
  title={translator("Dikkat!")}
  onClose={onModalClose}
>
  <div slot="modal-body">
    {translator(
      '"__EMPLOYEE__" tarafından yapılan __MAINTENANCECOST__₺ tutarındaki onarım kaydını kalıcı olarak silmek istediğinize emin misiniz?',
      {
        __EMPLOYEE__: maintenanceDetails.employee,
        __MAINTENANCECOST__: maintenanceDetails.cost,
      }
    )}
  </div>
  <div slot="modal-footer">
    <Button size="sm" onClick={onDeleteClick}>
      {translator("Sil")}
    </Button>
    <Button size="sm" onClick={toggler} colorCls="btn-dark">
      {translator("Vazgeç")}
    </Button>
  </div>
</Modal>
